// Logo.js
import { Link } from 'react-router-dom';

const Logo = () => (
  <div className="relative overflow-visible" style={{ width: '60px', height: '40px' }}>
    <Link to="/" className="block relative w-full h-full overflow-visible">
      <img
        src={process.env.PUBLIC_URL + '/images/logo 6.png'}
        alt="AutoSell.PL Logo"
        style={{
          position: 'absolute',
          top: '50%',
          left: '200%',
          transform: 'translate(-50%, -50%) scale(4)',
          filter: 'invert(13%) sepia(8%) saturate(1590%) hue-rotate(183deg) brightness(93%) contrast(89%)'
        }}
        className="object-contain"
      />
    </Link>
  </div>
);

export default Logo;